import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhTW from './zh-TW.json'
import en from './en.json'

const LANG_STORAGE_KEY = 'tg_game_lang'

function detectLanguage(): string {
  try {
    const stored = localStorage.getItem(LANG_STORAGE_KEY)
    if (stored === 'en' || stored === 'zh-TW') return stored
  } catch {
    /* ignore */
  }
  const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || ''
  if (nav.toLowerCase().startsWith('en')) return 'en'
  return 'zh-TW'
}

void i18n.use(initReactI18next).init({
  resources: {
    'zh-TW': { translation: zhTW },
    en: { translation: en },
  },
  lng: detectLanguage(),
  fallbackLng: 'zh-TW',
  supportedLngs: ['zh-TW', 'en'],
  interpolation: { escapeValue: false },
})

if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'zh-Hant'
}

export function translateError(codeOrMessage: string | null | undefined, t: (k: string) => string): string {
  if (!codeOrMessage) return t('errors.unknown')
  const key = `errors.${codeOrMessage}`
  const mapped = t(key)
  if (mapped !== key) return mapped
  const lower = codeOrMessage.toLowerCase()
  if (lower.includes('insufficient')) return t('errors.insufficient_funds')
  if (lower.includes('invalid amount') || lower.includes('below minimum') || lower.includes('above maximum')) {
    return t('errors.invalid_amount')
  }
  if (lower.includes('betting')) return t('errors.not_betting')
  if (lower.includes('running')) return t('errors.not_running')
  if (lower.includes('already placed') || lower.includes('already bet')) return t('errors.already_bet')
  if (lower.includes('no active')) return t('errors.no_bet')
  if (lower.includes('cashed')) return t('errors.already_cashout')
  if (lower.includes('login') || lower.includes('unauthorized')) return t('errors.unauthorized')
  return t('errors.request_failed')
}

export default i18n
